export type Session = {
  customer_email: string;
  customer_num: number;
  customer_name: string;
  cart_products_count: number;
  is_net_wos: boolean;
};
